import React from 'react'
import PropTypes from 'prop-types'
import BarChartTable from '../../Helpers/BarChartTable'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'

function PortfolioBarChart({ meta, fund }) {
  const barChart = new BarChartTable({
    tableId: meta.tableId,
    details: meta.details,
    chartInfo: {
      title: meta.headingLabel,
      chartLabel1: 'Fund',
      chartLabel2: '',
    },
    fund: fund,
  })

  return (
    <div id={meta.tableId} className="u-paddingTop6gu">
      <h3 className="u-marginBottom4gu">
        {meta.sectionLabel}{' '}
        <span className="u-textColorLight u-textNormal u-textSolid u-textSecondary">
          as of {formatDateStandard(meta.asOfDate)}
        </span>
      </h3>

      <div>{barChart.render()}</div>

      {meta.disclosure && (
        <div
          className="Disclaimer u-marginTop4gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0 u-paddingBottom6gu"
          data-qa-automation={`disclosure-${meta.tableId}`}
        >
          <h5 className="Disclaimer-heading">{meta.disclosureTitle}</h5>
          <div
            className="Disclaimer-text"
            dangerouslySetInnerHTML={{ __html: meta.disclosure }}
          ></div>
        </div>
      )}
    </div>
  )
}
PortfolioBarChart.propTypes = {
  fund: PropTypes.object,
  meta: PropTypes.object,
}

export default PortfolioBarChart
